var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { AppCreationScreens, AppCreationTypes, } from './models';
import { loadApps } from '../../containers/Root/actions';
import services from '../../services';
var AppService = services.AppService, TemplatesService = services.TemplatesService, OrganizationService = services.OrganizationService, EnvironmentService = services.EnvironmentService, StyleService = services.StyleService;
/**
 * open app creation flow popover
 * @return {undefined} no return values
 */
export var openCreateAppFlow = function () { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        try {
            dispatch({ type: 'SET_OPEN_APP_FLOW' });
        }
        catch (err) {
            dispatch({
                type: 'SET_APP_CREATION_FLOW_ERROR',
            });
        }
        return [2 /*return*/];
    });
}); }; };
/**
 * close app creation flow popover
 * @return {undefined} no return values
 */
export var closeCreateAppFlow = function () {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            try {
                dispatch({ type: 'SET_CLOSE_APP_FLOW' });
            }
            catch (err) {
                dispatch({
                    type: 'SET_APP_CREATION_FLOW_ERROR',
                });
            }
            return [2 /*return*/];
        });
    }); };
};
/**
 * navigate between app steps
 * @param  {AppCreationScreens} stepName current step name SELECT_TYPE, SET_NAME_AND_ICON, SET_GLOBAL_STYLES_COLOR, SET_GLOBAL_STYLES_TEXT, SET_CREATING_APP, EXPLORE_TEMPLATES, SET_ENVIRONMENT_VARIABLES
 * @param  {AppCreationTypes} create flow type SCRATCH, TEMPLATE
 * @param  {AppCreationScreens | null} next next step name SELECT_TYPE, SET_NAME_AND_ICON, SET_GLOBAL_STYLES_COLOR, SET_GLOBAL_STYLES_TEXT, SET_CREATING_APP, EXPLORE_TEMPLATES, SET_ENVIRONMENT_VARIABLES
 * @param  {AppCreationScreens | null} previous previous step name SELECT_TYPE, SET_NAME_AND_ICON, SET_GLOBAL_STYLES_COLOR, SET_GLOBAL_STYLES_TEXT, SET_CREATING_APP, EXPLORE_TEMPLATES, SET_ENVIRONMENT_VARIABLES
 * @return {undefined} no return values
 */
export var setCreateAppStep = function (stepName, create, next, previous) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            try {
                dispatch({
                    type: 'SET_APP_CREATION_STEP',
                    step: stepName,
                    createType: create,
                    next: next,
                    previous: previous,
                });
            }
            catch (err) {
                dispatch({
                    type: 'SET_APP_CREATION_FLOW_ERROR',
                });
            }
            return [2 /*return*/];
        });
    }); };
};
/**
 * edit color variable on the redux data object
 * @param  {string} name color variable name (not being modified within app creation flow)
 * @param  {string} value color variable value (hex code)
 * @param  {number} index index number of the color variable within the 10 slots
 * @return {undefined} no return values
 */
export var editAppColor = function (name, value, index) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            try {
                dispatch({
                    type: 'SET_APP_COLOR',
                    index: index,
                    value: value,
                    name: name,
                });
            }
            catch (err) {
                dispatch({
                    type: 'SET_APP_CREATION_FLOW_ERROR',
                });
            }
            return [2 /*return*/];
        });
    }); };
};
/**
 * edit text variable on the redux data object
 * @param  {string} name text variable name (not being modified within app creation flow)
 * @param  {TextStyleValues} values text variable values (font size/ font weight/ letter spacing/)
 * @param  {number} index index number of the color variable within the 10 slots
 * @return {undefined} no return values
 */
export var editAppText = function (name, values, index) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            try {
                dispatch({
                    type: 'SET_APP_TEXT',
                    index: index,
                    fontFamily: values === null || values === void 0 ? void 0 : values.fontFamily,
                    fontSize: values === null || values === void 0 ? void 0 : values.fontSize,
                    fontWeight: values === null || values === void 0 ? void 0 : values.fontWeight,
                    letterSpacing: values === null || values === void 0 ? void 0 : values.letterSpacing,
                    name: name,
                });
            }
            catch (err) {
                dispatch({
                    type: 'SET_APP_CREATION_FLOW_ERROR',
                });
            }
            return [2 /*return*/];
        });
    }); };
};
/**
 * open/close color picker popover
 * @param  {string | null} id index/id of the color slot in the redux state
 * @param  {boolean} open open/ close color picker popover
 * @return {undefined} no return values
 */
export var openColorPopUp = function (id, open) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            try {
                dispatch({
                    type: 'SET_COLOR_POPUP',
                    id: id,
                    open: open,
                });
            }
            catch (err) {
                dispatch({
                    type: 'SET_APP_CREATION_FLOW_ERROR',
                });
            }
            return [2 /*return*/];
        });
    }); };
};
/**
 * open/close cancel app creation popover
 * @param  {string} open open/ close app creation flow terminate popover
 * @return {undefined} no return values
 */
export var toggleConfirmCancelPopUp = function (open) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            try {
                dispatch({
                    type: 'SET_CONFIRM_CLOSE',
                    open: open,
                });
            }
            catch (err) {
                dispatch({
                    type: 'SET_APP_CREATION_FLOW_ERROR',
                });
            }
            return [2 /*return*/];
        });
    }); };
};
/**
 * edit app name and logo
 * @param  {string} value set app name/logo (if value (name) is empty, set a validation error)
 * @param  {AppEditTypes} type edit type NAME / LOGO
 * @return {undefined} no return values
 */
export var changeAppNameAndLogo = function (value, type) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            try {
                if (type === 'NAME') {
                    dispatch({
                        type: 'SET_APP_NAME',
                        name: value,
                    });
                    if (value === '') {
                        dispatch({ type: 'SET_APP_NAME_IS_EMPTY', isNameEmpty: true });
                    }
                    else {
                        dispatch({ type: 'SET_APP_NAME_IS_EMPTY', isNameEmpty: false });
                    }
                }
                else {
                    dispatch({
                        type: 'SET_APP_LOGO',
                        logo: value,
                    });
                }
            }
            catch (err) {
                dispatch({
                    type: 'SET_APP_CREATION_FLOW_ERROR',
                });
            }
            return [2 /*return*/];
        });
    }); };
};
/**
 * open or hover template info popover
 * @param  {boolean} open open/close template more info popover on templates page
 * @return {undefined} no return values
 */
export var toggleTemplateInfoPopUp = function (open) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            try {
                dispatch({
                    type: 'SET_TEMPLATE_INFO',
                    open: open,
                });
            }
            catch (err) {
                dispatch({
                    type: 'SET_APP_CREATION_FLOW_ERROR',
                });
            }
            return [2 /*return*/];
        });
    }); };
};
/**
 * reset the all states related to app creation flow to default
 * @return {undefined} no return values
 */
export var resetAppCreationState = function () {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            try {
                dispatch({
                    type: 'RESET_APP_CREATION_STATE',
                });
            }
            catch (err) {
                dispatch({
                    type: 'SET_APP_CREATION_FLOW_ERROR',
                });
            }
            return [2 /*return*/];
        });
    }); };
};
/**
 * select a template
 * @param  {string} id template id
 * @param  {string | null} colorId template color view id
 * @param  {string | null} typographyId template typography color view id
 * @param  {string} icon template icon
 * @param  {string} appId template app id
 * @param  {boolean} includeData template (if or if not) include data
 * @param  {number | null} version template version
 * @return {undefined} no return values
 */
export var selectTemplate = function (id, colorId, typographyId, icon, appId, includeData, version) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            try {
                dispatch({
                    type: 'SET_SELECTED_TEMPLATE',
                    templateId: id,
                    templateColor: colorId,
                    templateTypography: typographyId,
                    templateIcon: icon,
                    templateAppId: appId,
                    templateIncludeData: includeData,
                    templateVersion: version,
                });
            }
            catch (err) {
                dispatch({
                    type: 'SET_APP_CREATION_FLOW_ERROR',
                });
            }
            return [2 /*return*/];
        });
    }); };
};
/**
 * update environment variable value
 * @param  {string} templateId template id
 * @param  {string} appId appId id
 * @param  {any} envData env data object
 * @return {undefined} no return values
 */
export var updateEnvironmentData = function (templateId, appId, envData) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    dispatch({ type: 'GET_ENVIRONMENT_DATA_REQUEST' });
                    return [4 /*yield*/, EnvironmentService.updateEnvInApp(templateId, appId, envData)];
                case 1:
                    _a.sent();
                    dispatch({ type: 'GET_ENVIRONMENT_DATA_SUCCESS', data: [] });
                    return [3 /*break*/, 3];
                case 2:
                    err_1 = _a.sent();
                    dispatch({
                        type: 'GET_ENVIRONMENT_DATA_FAILURE',
                    });
                    dispatch({ type: 'GET_ENVIRONMENT_DATA_FAILURE' });
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
};
/**
 * fetch global styles related to a template
 * @param  {string} styleId app id
 * @return {undefined} no return values
 */
export var getStyleData = function (styleId) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var object, err_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    dispatch({ type: 'STYLE_DATA_REQUEST' });
                    return [4 /*yield*/, StyleService.getStyle(styleId)];
                case 1:
                    object = (_a.sent()).object;
                    dispatch({
                        type: 'STYLE_DATA_SUCCESS',
                        styleObj: object === null || object === void 0 ? void 0 : object.data,
                        styleName: object === null || object === void 0 ? void 0 : object.name,
                        styleDescription: object === null || object === void 0 ? void 0 : object.description,
                    });
                    return [3 /*break*/, 3];
                case 2:
                    err_2 = _a.sent();
                    dispatch({ type: 'STYLE_DATA_FAILURE' });
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
};
/**
 * create an app
 * @param  {string} name app name
 * @param  {string} organizationId org id
 * @param  {string} template template if it is being used ('blank') if the app is from scratch
 * @param  {boolean} template_with_data if or if not includes template data
 * @param  {AppStyleData} data template app style data object
 * @param  {string} icon template icon
 * @param  {string} app_for_template app id for template
 * @param  {number} version version number of template
 * @param  {number} newerVersion v18 number
 * @param  {AppCreateTypes} createMode if scratch, SCRATCH, if primary, PRIMARY (template app v18+), ADDITIONAL (template app v18+ env and global styles)
 * @param  {any=} createdTemplateApp created template app (if v18+)
 * @param  {any=} envData environment id
 * @param  {any=} styleName global style name
 * @param  {any=} styleDescription global style description
 * @return {undefined} no return values
 */
export var create = function (name, organizationId, template, template_with_data, data, icon, app_for_template, version, newerVersion, createMode, styleName, styleDescription, navigate, createdTemplateApp, envData) {
    if (template === void 0) { template = 'blank'; }
    if (template_with_data === void 0) { template_with_data = false; }
    if (icon === void 0) { icon = ''; }
    if (app_for_template === void 0) { app_for_template = '0'; }
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var app, appObj, ex_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch({
                        type: 'SET_CREATE_APP_REQUEST',
                    });
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 8, , 9]);
                    if (!(createMode !== 'ADDITIONAL')) return [3 /*break*/, 3];
                    return [4 /*yield*/, AppService.createApp(name, organizationId, template, template_with_data, app_for_template, icon, {
                            name: 'Theme 1',
                            description: 'Default Theme',
                            data: data,
                        })];
                case 2:
                    app = (_a.sent()).object;
                    if (app) {
                        if (version < newerVersion || createMode === 'COMPLETE') {
                            dispatch(loadApps());
                            dispatch({
                                type: 'SET_CREATE_APP_SUCCESS',
                            });
                            dispatch({
                                type: 'RESET_APP_CREATION_STATE',
                            });
                            return [2 /*return*/, navigate("/organizations/".concat(organizationId, "/apps/").concat(app.id, "/overview"))];
                        }
                        else if (version >= newerVersion || createMode === 'PRIMARY') {
                            if (app) {
                                dispatch({
                                    type: 'SET_CREATE_APP_SUCCESS',
                                });
                                dispatch({
                                    type: 'SET_CREATED_APP_MORE_DETAILS',
                                    appId: app === null || app === void 0 ? void 0 : app.id,
                                    styleId: app === null || app === void 0 ? void 0 : app.style,
                                });
                                dispatch(getStyleData(app === null || app === void 0 ? void 0 : app.style));
                                dispatch(setCreateAppStep(AppCreationScreens.SET_GLOBAL_STYLES_COLOR, AppCreationTypes.TEMPLATE, AppCreationScreens.SET_GLOBAL_STYLES_TEXT, AppCreationScreens.SET_NAME_AND_ICON));
                            }
                        }
                    }
                    return [3 /*break*/, 7];
                case 3:
                    dispatch({
                        type: 'SET_LOADING_MESSAGE',
                        text: 'Confirming  your color palette...',
                    });
                    return [4 /*yield*/, AppService.updateApp({
                            id: createdTemplateApp === null || createdTemplateApp === void 0 ? void 0 : createdTemplateApp.id,
                            name: name,
                            icon: icon,
                            style: createdTemplateApp.styleId,
                        })];
                case 4:
                    appObj = (_a.sent()).object;
                    dispatch({
                        type: 'SET_LOADING_MESSAGE',
                        text: "Updating your app's fonts..",
                    });
                    if (!appObj) return [3 /*break*/, 7];
                    return [4 /*yield*/, StyleService.updateStyleDraft(createdTemplateApp === null || createdTemplateApp === void 0 ? void 0 : createdTemplateApp.styleId, styleName, styleDescription, data)];
                case 5:
                    _a.sent();
                    return [4 /*yield*/, dispatch(loadApps())];
                case 6:
                    _a.sent();
                    dispatch({
                        type: 'SET_LOADING_MESSAGE',
                        text: "Your app is almost ready...",
                    });
                    if (envData === null || envData === void 0 ? void 0 : envData.length) {
                        dispatch(updateEnvironmentData(template, createdTemplateApp === null || createdTemplateApp === void 0 ? void 0 : createdTemplateApp.id, envData));
                    }
                    dispatch({
                        type: 'SET_CREATE_APP_SUCCESS',
                    });
                    dispatch({
                        type: 'RESET_APP_CREATION_STATE',
                    });
                    return [2 /*return*/, navigate("/organizations/".concat(organizationId, "/apps/").concat(appObj === null || appObj === void 0 ? void 0 : appObj.id, "/overview"))];
                case 7: return [3 /*break*/, 9];
                case 8:
                    ex_1 = _a.sent();
                    dispatch({
                        type: 'SET_CREATE_APP_FAILURE',
                    });
                    return [3 /*break*/, 9];
                case 9: return [2 /*return*/];
            }
        });
    }); };
};
/**
 * fetch template list
 * @param  {string} orgId organization id
 * @param  {string} categories filter by template category (in ids)
 * @param  {number} page pagination (current page) of templates list
 * @param  {string} name filter by name
 * @param  {string | null} type filter by type (solutions, functions, concepts) or null to get all
 * @param  {string} version template list versions (used only for legacy v17)
 * @return {undefined} no return values
 */
export var listTemplates = function (orgId, categories, page, name, type, version) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var app_templates, ex_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (type !== null) {
                        if (type === 'solution') {
                            dispatch({
                                type: 'GET_CATEGORIZED_TEMPLATES_REQUEST',
                                templateLoadingType: 'solutionsLoading',
                                templateErrorType: 'solutionsError',
                            });
                        }
                        else if (type === 'concept') {
                            dispatch({
                                type: 'GET_CATEGORIZED_TEMPLATES_REQUEST',
                                templateLoadingType: 'conceptsLoading',
                                templateErrorType: 'conceptsError',
                            });
                        }
                        else if (type === 'function') {
                            dispatch({
                                type: 'GET_CATEGORIZED_TEMPLATES_REQUEST',
                                templateLoadingType: 'functionsLoading',
                                templateErrorType: 'functionsError',
                            });
                        }
                        else if (type === '' && version !== '') {
                            dispatch({
                                type: 'GET_CATEGORIZED_TEMPLATES_REQUEST',
                                templateLoadingType: 'legacyLoading',
                                templateErrorType: 'legacyError',
                            });
                        }
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, TemplatesService.getTemplatesWithProps(orgId, page, 4, categories, name, type === null ? '' : type)];
                case 2:
                    app_templates = (_a.sent()).object;
                    if (type !== '') {
                        if (type === 'solution') {
                            dispatch({
                                type: 'Set_CATEGORIZED_TEMPLATES_SUCCESS',
                                templateType: 'solutions',
                                templateData: app_templates.app_templates,
                                templateLoadingType: 'solutionsLoading',
                                templateErrorType: 'solutionsError',
                            });
                        }
                        else if (type === 'concept') {
                            dispatch({
                                type: 'Set_CATEGORIZED_TEMPLATES_SUCCESS',
                                templateType: 'concepts',
                                templateData: app_templates.app_templates,
                                templateLoadingType: 'conceptsLoading',
                                templateErrorType: 'conceptsError',
                            });
                        }
                        else if (type === 'function') {
                            dispatch({
                                type: 'Set_CATEGORIZED_TEMPLATES_SUCCESS',
                                templateType: 'functions',
                                templateData: app_templates.app_templates,
                                templateLoadingType: 'functionsLoading',
                                templateErrorType: 'functionsError',
                            });
                        }
                        else if (type === 'legacy') {
                            dispatch({
                                type: 'Set_CATEGORIZED_TEMPLATES_SUCCESS',
                                templateType: 'legacy',
                                templateData: app_templates.app_templates,
                                templateLoadingType: 'legacyLoading',
                                templateErrorType: 'legacyError',
                            });
                        }
                    }
                    else {
                        if (version !== '') {
                            dispatch({
                                type: 'Set_CATEGORIZED_TEMPLATES_SUCCESS',
                                templateType: 'legacy',
                                templateData: app_templates.app_templates,
                                templateLoadingType: 'legacyLoading',
                                templateErrorType: 'legacyError',
                            });
                        }
                    }
                    return [3 /*break*/, 4];
                case 3:
                    ex_2 = _a.sent();
                    if (type !== '') {
                        if (type === 'solution') {
                            dispatch({
                                type: 'GET_CATEGORIZED_TEMPLATES_FAILURE',
                                templateLoadingType: 'solutionsLoading',
                                templateErrorType: 'solutionsError',
                            });
                        }
                        else if (type === 'concept') {
                            dispatch({
                                type: 'GET_CATEGORIZED_TEMPLATES_FAILURE',
                                templateLoadingType: 'conceptsLoading',
                                templateErrorType: 'conceptsError',
                            });
                        }
                        else if (type === 'function') {
                            dispatch({
                                type: 'GET_CATEGORIZED_TEMPLATES_FAILURE',
                                templateLoadingType: 'functionsLoading',
                                templateErrorType: 'functionsError',
                            });
                        }
                        else {
                            dispatch({
                                type: 'GET_CATEGORIZED_TEMPLATES_FAILURE',
                                templateLoadingType: 'legacyLoading',
                                templateErrorType: 'legacyError',
                            });
                        }
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
/**
 * set additional template more info
 * @param  {string} id template id
 * @param  {string} name template name
 * @param  {string} description template description
 * @param  {string} summary template summary
 * @param  {string} icon template icon
 * @param  {any} media template media
 * @param  {number} version template version
 * @param  {string[] | []} categories template categories
 * @param  {string[] | []} template_tags template tags
 * @param  {string} app template app id
 * @param  {string} type template type solution/ concept/ function
 * @param  {PreviewProps} preview template preview obj with view color id and view typography id
 * @param  {MetaProps} meta template images and video array
 * @return {undefined} no return values
 */
export var setTemplateMoreInfo = function (id, name, description, summary, icon, media, version, categories, template_tags, app, type, preview, meta) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            try {
                dispatch({
                    type: 'SET_TEMPLATE_MORE_INFO',
                    info: {
                        id: id,
                        name: name,
                        description: description,
                        summary: summary,
                        icon: icon,
                        media: media,
                        version: version,
                        categories: categories,
                        template_tags: template_tags,
                        app: app,
                        type: type,
                        preview: preview,
                        meta: meta,
                    },
                });
            }
            catch (ex) {
                dispatch({
                    type: 'SET_APP_CREATION_FLOW_ERROR',
                });
            }
            return [2 /*return*/];
        });
    }); };
};
/**
 * fetch and display categories
 * mutate category object and add property called selected to the object, so the chip can show the selected value
 * @param  {string} orgId template id
 * @return {undefined} no return values
 */
export var listCategories = function (orgId) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var categories, mutatedCategories_1, ex_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch({
                        type: 'GET_ORG_CATEGORIES_REQUEST',
                    });
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, OrganizationService.getOrganizationCategories(orgId)];
                case 2:
                    categories = (_a.sent()).objects;
                    if (categories.length) {
                    }
                    mutatedCategories_1 = [];
                    categories.map(function (category) {
                        mutatedCategories_1.push(__assign(__assign({}, category), { selected: false }));
                    });
                    dispatch({
                        type: 'GET_ORG_CATEGORIES_SUCCESS',
                        categories: mutatedCategories_1,
                    });
                    return [3 /*break*/, 4];
                case 3:
                    ex_3 = _a.sent();
                    dispatch({
                        type: 'GET_ORG_CATEGORIES_FAILURE',
                    });
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
/**
 * change category selection state
 * @param  {boolean} selection select true or false for a category
 * @param  {number} index category index
 * @return {undefined} no return values
 */
export var setCategories = function (selection, index) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            try {
                dispatch({
                    type: 'SET_SELECTED_CATEGORIES',
                    categorySelection: selection,
                    categoryIndex: index,
                });
            }
            catch (err) {
                dispatch({
                    type: 'SET_APP_CREATION_FLOW_ERROR',
                });
            }
            return [2 /*return*/];
        });
    }); };
};
/**
 * template type for the template type filter within the search
 * @param  {string | null} type type could be solutions/ functions/ concepts/ or all
 * @return {undefined} no return values
 */
export var setTemplateType = function (type) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            try {
                dispatch({
                    type: 'SET_SELECTED_TYPE',
                    name: type,
                });
            }
            catch (err) {
                dispatch({
                    type: 'SET_APP_CREATION_FLOW_ERROR',
                });
            }
            return [2 /*return*/];
        });
    }); };
};
/**
 * search a template by name
 * @param  {string} text search keyword
 * @return {undefined} no return values
 */
export var searchTemplates = function (text) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            try {
                dispatch({
                    type: 'SET_SEARCH_TEXT',
                    text: text,
                });
            }
            catch (err) {
                dispatch({
                    type: 'SET_APP_CREATION_FLOW_ERROR',
                });
            }
            return [2 /*return*/];
        });
    }); };
};
/**
 * generating a collection of category string for query params, separated with &= characters
 * @param  {string} text category id
 * @return {undefined} no return values
 */
export var changeCategoryText = function (text) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            try {
                dispatch({
                    type: 'SET_CATEGORY_TEXT',
                    text: text,
                });
            }
            catch (err) {
                dispatch({
                    type: 'SET_APP_CREATION_FLOW_ERROR',
                });
            }
            return [2 /*return*/];
        });
    }); };
};
/**
 * search a template by name
 * @param  {string} text search keyword
 * @return {undefined} no return values
 */
export var setSearchType = function (text) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            try {
                dispatch({
                    type: 'SET_SEARCH_TYPE',
                    searchType: text,
                });
            }
            catch (err) {
                dispatch({
                    type: 'SET_APP_CREATION_FLOW_ERROR',
                });
            }
            return [2 /*return*/];
        });
    }); };
};
/**
 * clear pagination of template pagination
 * @return {undefined} no return values
 */
export var clearPages = function () {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            try {
                dispatch({
                    type: 'CLEAR_AND_SEARCH_FILTERS',
                    solutions: [],
                    concepts: [],
                    functions: [],
                    legacy: [],
                    solutionsCurrentPage: 1,
                    solutionsTotalPages: null,
                    solutionsLoading: false,
                    solutionsError: false,
                    conceptsCurrentPage: 1,
                    conceptsTotalPages: null,
                    conceptsLoading: false,
                    conceptsError: false,
                    functionsCurrentPage: 1,
                    functionsTotalPages: null,
                    functionsLoading: false,
                    functionsError: false,
                    legacyCurrentPage: 1,
                    legacyTotalPages: null,
                    legacyLoading: false,
                    legacyError: false,
                });
            }
            catch (err) {
                dispatch({
                    type: 'SET_APP_CREATION_FLOW_ERROR',
                });
            }
            return [2 /*return*/];
        });
    }); };
};
/**
 * fetch templates based on any active search filter (category/ searchString or filter)
 * add search results on top if currently an active search is applied
 * @param  {string} orgId organization id
 * @param  {string} categories selected category string separated by &=
 * @param  {number} page current page of the current search results
 * @param  {string} name search keyword
 * @param  {string | null} type search type solution/ concept/ functions/ legacy or all
 * @param  {any[]} currentData current search result
 * @return {undefined} no return values
 */
export var activeSearchTemplates = function (orgId, categories, page, name, type, currentData) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, _b, app_templates, total_templates, pagination, mutableAppTemplates_1, ex_4;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _c.trys.push([0, 2, , 3]);
                    dispatch({
                        type: 'ACTIVE_SEARCH_RESULTS_REQUEST',
                    });
                    return [4 /*yield*/, TemplatesService.getTemplatesWithProps(orgId, page, 16, categories, name, type === null ? '' : type)];
                case 1:
                    _a = _c.sent(), _b = _a.object, app_templates = _b.app_templates, total_templates = _b.total_templates, pagination = _a.meta.pagination;
                    mutableAppTemplates_1 = currentData;
                    app_templates.map(function (data) {
                        mutableAppTemplates_1.push(data);
                    });
                    dispatch({
                        type: 'ACTIVE_SEARCH_RESULTS_SUCCESS',
                        results: mutableAppTemplates_1,
                        currentPage: pagination.current,
                        totalPages: pagination.total_pages,
                        templateCount: total_templates,
                    });
                    return [3 /*break*/, 3];
                case 2:
                    ex_4 = _c.sent();
                    dispatch({
                        type: 'ACTIVE_SEARCH_RESULTS_FAILURE',
                    });
                    dispatch({
                        type: 'SET_APP_CREATION_FLOW_ERROR',
                    });
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
};
/**
 * clear active search results
 * usually dispatched when the dropdown for type changes/ search string changes or category selection changes
 * @return {undefined} no return values
 */
export var clearActiveSearchResults = function () {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            try {
                dispatch({
                    type: 'CLEAR_ACTIVE_SEARCH_RESULTS',
                });
            }
            catch (err) {
                dispatch({
                    type: 'SET_APP_CREATION_FLOW_ERROR',
                });
            }
            return [2 /*return*/];
        });
    }); };
};
/**
 * clear selected template data (happens when user switches template or searches templates when a template is selected)
 * also blocks the user from proceeding without selecting a template
 * @return {undefined} no return values
 */
export var clearSelectedTemplate = function () {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            try {
                dispatch({
                    type: 'RESET_SELECTED_TEMPLATE',
                });
            }
            catch (err) {
                dispatch({
                    type: 'SET_APP_CREATION_FLOW_ERROR',
                });
            }
            return [2 /*return*/];
        });
    }); };
};
/**
 * delete app if the user terminates the app creation process
 * @param  {string} appId app id to delete
 * @return {undefined} no return values
 */
export var deleteInCompleteApp = function (appId) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var err_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    dispatch({ type: 'DELETE_INCOMPLETE_APP_REQUEST' });
                    return [4 /*yield*/, AppService.deleteApp(appId)];
                case 1:
                    _a.sent();
                    dispatch({ type: 'DELETE_INCOMPLETE_APP_SUCCESS' });
                    return [3 /*break*/, 3];
                case 2:
                    err_3 = _a.sent();
                    dispatch({
                        type: 'SET_APP_CREATION_FLOW_ERROR',
                    });
                    dispatch({ type: 'DELETE_INCOMPLETE_APP_FAILURE' });
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
};
/**
 * fetch env variables related to a template
 * @param  {string} templateId template id
 * @return {undefined} no return values
 */
export var getEnvironmentData = function (templateId) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var environments, err_4;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    dispatch({ type: 'GET_ENVIRONMENT_DATA_REQUEST' });
                    return [4 /*yield*/, TemplatesService.getTemplateEnvironmentData(templateId)];
                case 1:
                    environments = (_a.sent()).objects;
                    dispatch({ type: 'GET_ENVIRONMENT_DATA_SUCCESS', data: environments });
                    return [3 /*break*/, 3];
                case 2:
                    err_4 = _a.sent();
                    dispatch({
                        type: 'GET_ENVIRONMENT_DATA_FAILURE',
                    });
                    dispatch({ type: 'GET_ENVIRONMENT_DATA_FAILURE' });
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
};
/**
 * edit env variables on the redux state
 * so the edited data can be submitted when completing the template app
 * @param  {string} indexOf index of the template env variable in the redux state
 * @param  {string} valueData template variable new value to be assigned
 * @param  {string} fieldName template variable value name (most of the time the 'value') property
 * @param  {string} fieldType template field input type
 * @return {undefined} no return values
 */
export var editEnvironmentData = function (indexOf, valueData, fieldName, fieldType) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var valueObj;
        return __generator(this, function (_a) {
            try {
                valueObj = void 0;
                if (fieldType === 'location') {
                    valueObj = {
                        lon: valueData[fieldName].lon,
                        lat: valueData[fieldName].lat,
                    };
                }
                else {
                    valueObj = valueData[fieldName];
                }
                dispatch({
                    type: 'EDIT_ENVIRONMENT_DATA_STATE',
                    index: indexOf,
                    value: { value: valueObj },
                });
            }
            catch (err) {
                console.log('err', err);
            }
            return [2 /*return*/];
        });
    }); };
};
/**
 * open request template app
 * @param  {boolean} open open true or false value
 * @return {undefined} no return values
 */
export var openRequestTemplateModal = function (open) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            try {
                dispatch({ type: 'CHANGE_REQUEST_MODAL_STATE', open: open });
            }
            catch (err) {
                dispatch({
                    type: 'SET_APP_CREATION_FLOW_ERROR',
                });
            }
            return [2 /*return*/];
        });
    }); };
};
/**
 * fetch template list
 * @param  {string} orgId organization id
 * @return {undefined} no return values
 */
export var loadInitialTemplates = function (orgId) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var app_templates, solutions_1, functions_1, concepts_1, legacy_1, err_5;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    dispatch({ type: 'GET_INITIAL_TEMPLATES_REQUEST' });
                    return [4 /*yield*/, TemplatesService.getInitialTemplates(orgId)];
                case 1:
                    app_templates = (_a.sent()).object;
                    solutions_1 = [];
                    functions_1 = [];
                    concepts_1 = [];
                    legacy_1 = [];
                    (app_templates.app_templates || []).map(function (template) {
                        if ((template === null || template === void 0 ? void 0 : template.type) === 'solution') {
                            solutions_1 === null || solutions_1 === void 0 ? void 0 : solutions_1.push(template);
                        }
                        else if ((template === null || template === void 0 ? void 0 : template.type) === 'function') {
                            functions_1 === null || functions_1 === void 0 ? void 0 : functions_1.push(template);
                        }
                        else if ((template === null || template === void 0 ? void 0 : template.type) === 'concept') {
                            concepts_1 === null || concepts_1 === void 0 ? void 0 : concepts_1.push(template);
                        }
                        else {
                            legacy_1 === null || legacy_1 === void 0 ? void 0 : legacy_1.push(template);
                        }
                    });
                    dispatch({
                        type: 'GET_INITIAL_TEMPLATES_SUCCESS',
                        solutionsArr: solutions_1,
                        conceptsArr: concepts_1,
                        functionsArr: functions_1,
                        legacyArr: legacy_1,
                    });
                    return [3 /*break*/, 3];
                case 2:
                    err_5 = _a.sent();
                    dispatch({ type: 'GET_INITIAL_TEMPLATES_FAILURE' });
                    dispatch({
                        type: 'SET_APP_CREATION_FLOW_ERROR',
                    });
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
};
/**
 * set env variable validation status (true if all required fields are true, else false)
 * @param  {boolean} status status value
 * @return {undefined} no return values
 */
export var setEnvStatus = function (status) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            try {
                dispatch({
                    type: 'SET_ENV_VALIDATIONS',
                    status: status,
                });
            }
            catch (err) {
                dispatch({
                    type: 'SET_APP_CREATION_FLOW_ERROR',
                });
            }
            return [2 /*return*/];
        });
    }); };
};
/**
 * set if continue is disabled or not in templates page
 * @param  {boolean} disabled if/not disabled
 * @return {undefined} no return values
 */
export var setIsContinueDisabled = function (disabled) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            try {
                dispatch({
                    type: 'SET_IS_CONTINUE_DISABLED',
                    disabled: disabled,
                });
            }
            catch (err) {
                dispatch({
                    type: 'SET_APP_CREATION_FLOW_ERROR',
                });
            }
            return [2 /*return*/];
        });
    }); };
};
/**
 * open request template app
 * @param  {boolean} open open true or false value
 * @return {undefined} no return values
 */
export var openQuotaNotAvailablePopover = function (open) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            try {
                dispatch({ type: 'IS_QUOTA_AVAILABLE_POPOVER_OPEN', open: open });
            }
            catch (err) {
                dispatch({
                    type: 'SET_APP_CREATION_FLOW_ERROR',
                });
            }
            return [2 /*return*/];
        });
    }); };
};
